// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BaseExtLink } from './BaseExtLink';
export class WebContainerExtLink extends BaseExtLink {
    update(brandingTool, extLinkMessage) {
        super.update(brandingTool, extLinkMessage);
        const changed = this.externalLinkWebconDark !== extLinkMessage.ExternalLinkWebContentDark ||
            this.externalLinkWebconLight !== extLinkMessage.ExternalLinkWebContentLight;
        this.externalLinkWebconDark = extLinkMessage.ExternalLinkWebContentDark;
        this.externalLinkWebconLight = extLinkMessage.ExternalLinkWebContentLight;
        if (changed && this.updateValue) {
            this.updateValue(this);
        }
    }
    getExternalLinkWebContent(isDark) {
        if (isDark) {
            if (!isNullOrUndefined(this.externalLinkWebconDark)) {
                return this.externalLinkWebconDark;
            }
            else {
                return this.externalLinkWebconLight;
            }
        }
        else {
            if (!isNullOrUndefined(this.externalLinkWebconLight)) {
                return this.externalLinkWebconLight;
            }
            else {
                return this.externalLinkWebconDark;
            }
        }
    }
}
